<div class="slider-container">
    <div class="popover-header">{{title}}</div>
    <div class="custom-slider">
        <ngx-slider
            [(value)]="value"
            [options]="options"
            (userChangeStart)="onUserChangeStart($event)"
            (userChange)="onUserChange($event)"
            (userChangeEnd)="onUserChangeEnd($event)">
        </ngx-slider>
    </div>
    <div class="popover-footer">
        <button nbButton size="tiny" (click)="onSubmit()">Apply</button>
    </div>
</div>
<!-- <ngx-slider [(value)]="value" [options]="options"></ngx-slider> -->

<!-- [manualRefresh]="<event emitter>"
    [triggerFocus]="<event emitter>"
    (userChangeStart)="<event handler>"
    (userChange)="<event handler>"
    (userChangeEnd)="<event handler>"
    (valueChange)="<event handler>"
    (highValueChange)="<event handler>" -->